// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .table-bordered th[data-v-77e4bf3b], [dir] td[data-v-77e4bf3b] {\r\n  border: 1px solid #dee2e6;\n}\r\n", ""]);
// Exports
module.exports = exports;
